import { z } from 'zod'
import { requiredString } from '../utils/basicSchemas/document.z.schema'
import { mongoId, mongoIdSchema } from '../utils/basicSchemas/_id.z.schema'
import { ZSchema } from '../utils/zodSchema'


const fundsDepositSchema = z.object({
    depositAmount: z.number(),
})
const fundsWithdrawalSchema = z.object({
    withdrawAmount: z.number(),
})
const fundsTransferSchema = z.object({
    fromWalletId: mongoId("From wallet id"),
    toWalletId: mongoId("To wallet id"),
    transferAmount: z.number(),
})

const walletIdSchema = z.object({
    id: mongoId("wallet id"),
})

const fundTransferValidator = new ZSchema({ bodySchema: fundsTransferSchema })
const fundDepositValidator = new ZSchema({ bodySchema: fundsDepositSchema, paramSchema: walletIdSchema })
const fundWithdrawValidator = new ZSchema({ bodySchema: fundsWithdrawalSchema, paramSchema: walletIdSchema })
const fundIdValidator = new ZSchema({ paramSchema: walletIdSchema })

export { fundTransferValidator, fundDepositValidator, fundWithdrawValidator, fundIdValidator };

